import './global.js';
import {
    v$,
    listen,
    compose,
    toggleHeight,
    initMap,
    renderList,
    generateBooleanArr,
    triger,
    Foreach
} from "./includes/helpers";
import handlePopup from './includes/popupForm';
import vRate from "./includes/vRate";
import 'js-marker-clusterer';
import loadGoogleMapsAPI from 'load-google-maps-api';

let reviewOfficePopup = v$('#review_office')[0],
    controlers = v$('.js-controler'),
    officeContents = v$('.offices-main-content'),
    openExtendedFilter = v$('.js-search_expanded')[0],
    clearFilterExpanded = v$('.offices-main-filter_expanded-clear')[0],
    filterExpanded = v$('.offices-main-filter_expanded')[0],
    listContainer = v$('.offices-main-content[data-content="list"] .wrapper')[0],
    regionCitySelect = v$('.offices-main-filter select'),
    filterCheckboxes = v$('.offices-main-filter_expanded-checkbox input[type="checkbox"]'),
    searchBtn = v$('.js-search')[0],
    citySelect = v$('.js-city')[0],
    regionSelect = v$('.js-region')[0],
    hiddenInputNumber = v$('.js-office_number')[0],
    foundOfficesCount = v$('.js-found_count')[0],
    mapElement = document.querySelector('.offices-main-content-map #map');
//data
const center = process.env.NODE_ENV === 'development' ? {lat: 50.451911, lng: 30.537246} : window.mapCenter,
    zoom = process.env.NODE_ENV === 'development' ? 10 : window.mapZoom,
    key = GoogleMapsKey,
    defaultRateObject = {
        generateInp: false,
        inpId: 'blago_rate_office',
        defaultRate: 5
    }
let officesData = [],
    wilReload = false,
    onList = false;

//functions
vRate('office_rate', defaultRateObject);

const getOfficeID = (target) => {
    let parent = target.parentNode.parentNode;
    return v$(".js-office_id", parent)[0].innerText;
};
const setIdToPopup = officeID => {
    let popupNum = v$('.popup-row-office_id', reviewOfficePopup)[0];
    popupNum.innerText = officeID;
    hiddenInputNumber.value = officeID;
    return true;
};
const resetPopup = (target) => {
    let inputs = v$('input', reviewOfficePopup),
        rateInp = v$('#blago_rate_office', reviewOfficePopup)[0],
        rateSpan = v$('#office_rate span');
    inputs.forEach(item => {
        item.value = ''
    });
    rateSpan.forEach(item => {
        item.className = 'active';
    });
    rateInp.value = defaultRateObject.defaultRate;
    return target;
};

const openReviewOfficePopup = compose(
    setIdToPopup,
    getOfficeID,
    resetPopup
);
const toggleMapList = ({target, type}) => {
    controlers.forEach(item => {
        item.className = item === target ? 'js-controler active' : 'js-controler';
    });
    officeContents.forEach(item => {
        let itemType = item.getAttribute('data-content');
        item.style.display = itemType === type ? 'flex' : 'none';
    });
    onList = type === 'list';
};
const clearExpandedFilter = (target) => {
    let inputs = v$('input', target),
        regionLiText = v$('li[rel="all"]', regionSelect.nextElementSibling.nextElementSibling)[0].textContent,
        cityLiText = v$('li[rel="all"]', citySelect.nextElementSibling.nextElementSibling)[0].textContent;
    inputs.forEach(item => {
        item.checked = false;
    });
    regionSelect.value = 'all';
    regionSelect.nextElementSibling.textContent = regionLiText;
    citySelect.value = 'all';
    citySelect.nextElementSibling.textContent = cityLiText;
    changeCityDependOnRegion(regionSelect.value);
};
const renderFunc = (item, id, container) => {
    let rateArr = generateBooleanArr(item.rate, 5);
    container.innerHTML += `<div class="offices-main-content-item ${item.withShop ? 'orange' : 'red' }">
            <div>
                <a href="${item.officeHref}">${process.env.NODE_ENV === 'development' ? 'Отделение' : window.JSI18N.t('frontend.one_office', 'office')}<span class="js-office_id">${item.number}</span></a>
                <b><a href="${item.officeHref}">${item.city_name}, ${item.address}</a></b>
                <p>${item.description}</p>
            </div>
            <div>
                <span>${process.env.NODE_ENV === 'development' ? 'Режим работы' : window.JSI18N.t('frontend.one_office', 'work_time')}</span>
                <b>${item.workTime}</b>
              <div class="offices-main-content-item-pay">
                  <span>${ process.env.NODE_ENV === 'development' ? 'Оплата' : window.JSI18N.t('frontend.one_office', 'payment_type')}</span>
                  <div class="offices-main-content-item-pay-cont">
                    <span class="payment_icons_cash" title="${ process.env.NODE_ENV === 'development' ? 'Наличными' : window.JSI18N.t('frontend.office.payment-type', 'csh')}"></span>`
        +
        (item.card ? ` <span class="payment_icons_cash credit_card ${item.card ? 'credit_card' : ''}" title="${ process.env.NODE_ENV === 'development' ? 'Картой' : window.JSI18N.t('frontend.office.payment-type', 'card')}"></span>` : ``)
        + `      </div>
              </div>
            </div>
            <div>
                <span class="offices-main-content-rate">${item.rate}
                    <div class="starrr_small">
                        <span class="fa ${rateArr[0] ? 'fa-star' : ''}"></span>
                        <span class="fa ${rateArr[1] ? 'fa-star' : ''}"></span>
                        <span class="fa ${rateArr[2] ? 'fa-star' : ''}"></span>
                        <span class="fa ${rateArr[3] ? 'fa-star' : ''}"></span>
                        <span class="fa ${rateArr[4] ? 'fa-star' : ''}"></span>
                    </div>
                </span>
              <button class="btn js-review_office">${process.env.NODE_ENV === 'development' ? 'Оценить отделение' : window.JSI18N.t('frontend.one_office', 'rate_office')}</button>
            </div>
          </div>`;
};
//check checkbox and select city (styled-options text) depend on location.href
const setFilters = (url) => {
    let objectFromUrl = url.split('/'),
        cityValue = citySelect.options[citySelect.options.selectedIndex].textContent,
        regionSelect = v$('.js-region')[0],
        regionSelectValue = regionSelect.options[regionSelect.options.selectedIndex].textContent;
    filterCheckboxes.forEach(item => {
        item.checked = objectFromUrl.includes(item.name);
    });
    citySelect.nextElementSibling.textContent = cityValue;
    regionSelect.nextElementSibling.textContent = regionSelectValue;
}
setFilters(location.href);
const modifyURL = () => {
    let checkbox = v$('.offices-main-filter_expanded input[type="checkbox"]'),
        url = '',
        cityValue = citySelect.value !== 'all' ? citySelect.value : false;
    checkbox.forEach(item => {
        url = item.checked ? url + `${item.name}/` : url;
    });
    return cityValue ? `${cityValue}/${url}` : `${url}`;
};
const pasteQueryToHref = (data) => {
    let lang = process.env.NODE_ENV === 'development'
        ? false
        : window.JSI18N.activeLanguage.code === window.JSI18N.defaultLanguage.code
            ? false
            : window.JSI18N.activeLanguage.code,
        pathNameArr = location.pathname.split('/'),
        pathName = process.env.NODE_ENV === 'development'
            ? pathNameArr[1]
            : window.JSI18N.activeLanguage.code !== window.JSI18N.defaultLanguage.code
                ? pathNameArr[2]
                : pathNameArr[1],
        startUrl = lang
            ? `${location.protocol}//${location.host}/${lang}/${pathName}`
            : `${location.protocol}//${location.host}/${pathName}`,
        url = data.length > 0 ? `${startUrl}/${data}` : `${startUrl}`;
    searchBtn.href = onList ? `${url}#list` : url;
};

const pasteQueryToUrl = (data) => {
    let url = searchBtn.href;
    history.pushState({newUrL: url}, 'filter', url);
    return data
};
const sliceData = (data, initial = 0, end = 10) => data.slice(initial, end);
const updateMap = data => {
    //TODO : придумать способ обновления карты по лучше чем ее ререндер
    initMap({
        data,
        zoom,
        center,
        element: mapElement
    });
    return data;
};
const removeOldList = data => {
    listContainer.innerHTML = '';
    return data
};
const updateList = data => {
    renderList(
        data,
        renderFunc,
        listContainer
    )
    return data;
};
const changeFoundOffices = data => {
    foundOfficesCount.textContent = data.length;
    return data;
};
const updateBtnTriggers = () => {
    //if we have empty arr on response v$('.js-review_office') will return false, in this case btns should be empty arr
    let btns = v$('.js-review_office', false, 0) || [];
    btns.forEach(item => {
        handlePopup(reviewOfficePopup, item);
        if (item) {
            item.addEventListener('click', e => {
                openReviewOfficePopup(e.target);
            })
        }
    })
};
const filterOfficesMapList = compose(
    updateBtnTriggers,
    updateList,
    removeOldList,
    sliceData,
    changeFoundOffices,
    updateMap,
    pasteQueryToUrl
);
const changeCityDependOnRegion = value => {
    let availableRel = [];
    Foreach(citySelect.options, (item) => {
        availableRel = availableRel.concat(item.getAttribute('data-region_id') === value ? [item.value] : []);
    });
    v$('li', citySelect.nextElementSibling.nextElementSibling).forEach(item => {
        item.style.display = availableRel.includes(item.getAttribute('rel')) ? 'flex' : value === 'all' ? 'flex' : 'none';
    });
    citySelect.value = availableRel[0];
    let ev = new Event('change', {cancelable: true});
    citySelect.dispatchEvent(ev);
    citySelect.nextElementSibling.textContent = !v$('.js-city option[selected]')[0] ? v$(`li[rel="${availableRel[0]}"]`)[0].textContent : v$('.js-city option[selected]')[0].textContent;
};

const changeRegionDependOnCity = value => {
    const dataRegionId = v$(`option[value="${value}"]`, citySelect)[0].getAttribute('data-region_id'),
          regionOption = v$(`option[value="${dataRegionId}"]`, regionSelect)[0];
    regionSelect.value = regionOption.value;
    regionSelect.nextElementSibling.textContent = regionOption.textContent;
};

const checkHashList = url => {
    let listControler = v$('.js-controler[data-controler="list"]')[0],
        showList = url.split('#').includes('list');
    if (showList) {
        toggleMapList({
            target: listControler,
            type: 'list'
        })
    }
};
checkHashList(location.href);
if (process.env.NODE_ENV === 'development') {
    fetch('data/officeData.json')
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject(new Error(response.statusText))
            }
            return Promise.resolve(response)
        })
        .then(response => response.json())
        .then(data => {
            officesData = data;
            renderList(
                sliceData(data, 0, 10),
                renderFunc,
                listContainer
            );
            updateBtnTriggers();
            loadGoogleMapsAPI({
                key,
                libraries: ['geometry', 'places']
            }).then(function (googleMaps) {
                initMap({
                    data,
                    zoom,
                    center,
                    element: mapElement
                });
            }).catch((err) => {
                console.error(err)
            })
        })
        .catch(error => {
            console.log('error', error)
        })

}
else {
    officesData = window.officesData;
    loadGoogleMapsAPI({
        key,
        libraries: ['geometry', 'places']
    }).then(function (googleMaps) {
        initMap({
            data: officesData,
            zoom,
            center,
            element: mapElement
        });
    }).catch((err) => {
        console.error(err)
    });
    renderList(
        sliceData(officesData, 0, 10),
        renderFunc,
        listContainer
    );
    updateBtnTriggers();
}

window.addEventListener('scroll', e => {
    triger(v$('.js-scroll_triger'), 'bottom', '20', () => {
        let lastRenderIndex = v$('.offices-main-content-item', false, 0).length,
            slicedOffices = sliceData(officesData, lastRenderIndex, lastRenderIndex + 10);
        if (v$('[data-controler="list"]')[0].className.includes('active') && slicedOffices.length > 0) {
            renderList(
                slicedOffices,
                renderFunc,
                listContainer
            );
            updateBtnTriggers();
        }
    })
});
listen(controlers, 'click', e => {
    let type = e.target.getAttribute('data-controler');
    toggleMapList({
        target: e.target,
        type
    })
    pasteQueryToHref(modifyURL());
});
listen(openExtendedFilter, 'click', (e) => {
    let target = e.target;
    target.className.includes('active') ? target.classList.remove('active') : target.classList.add('active');
    toggleHeight(filterExpanded);
});
listen(clearFilterExpanded, 'click', () => {
    clearExpandedFilter(filterExpanded)
    pasteQueryToHref(modifyURL());
});
listen(regionCitySelect, 'change', () => {
    wilReload = true;
});
searchBtn.addEventListener('click', e => {
    if (!wilReload) {
        e.preventDefault();
        if (process.env.NODE_ENV === 'development') {
            // let fakeNewArr = [
            //     {
            //         "position": {
            //             "lat": 53.450303,
            //             "lng": 31.468624
            //         },
            //         "withShop": false,
            //         "number": 21,
            //         "address": "г. Киев. ул. Северная, 60",
            //         "description": "Продажа золота, продажа техники, прием техники, прием золота/серебра, обмен техники",
            //         "workTime": "Пн-Вс: 9:00 - 21:00",
            //         "card": true,
            //         "rate": 4
            //     },
            //     {
            //         "position": {
            //             "lat": 53.450303,
            //             "lng": 30.468624
            //         },
            //         "options": {
            //             "reception_gold_silver": true
            //         },
            //         "withShop": true,
            //         "number": 22,
            //         "address": "г. Киев. ул. Северная, 60",
            //         "description": "Продажа золота, продажа техники, прием техники, прием золота/серебра, обмен техники",
            //         "workTime": "Пн-Вс: 9:00 - 21:00",
            //         "card": true,
            //         "rate": 4
            //     },
            //     {
            //         "position": {
            //             "lat": 53.450303,
            //             "lng": 30.468624
            //         },
            //         "options": {
            //             "reception_gold_silver": true
            //         },
            //         "withShop": true,
            //         "number": 22,
            //         "address": "г. Киев. ул. Северная, 60",
            //         "description": "Продажа золота, продажа техники, прием техники, прием золота/серебра, обмен техники",
            //         "workTime": "Пн-Вс: 9:00 - 21:00",
            //         "card": true,
            //         "rate": 4
            //     }
            // ];
            // officesData = fakeNewArr;
            // filterOfficesMapList(fakeNewArr);
            fetch('/api/offices', {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(response => {
                    if (response.status !== 200) {
                        return Promise.reject(new Error(response.statusText))
                    }
                    return Promise.resolve(response)
                })
                .then(response => response.json())
                .then(data => {
                    // console.log('response data:', data);
                    officesData = data;
                    filterOfficesMapList(data);
                })
                .catch(error => {
                    console.log('error', error)
                });
        } else {
            fetch(e.target.href, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(response => {
                    if (response.status !== 200) {
                        return Promise.reject(new Error(response.statusText))
                    }
                    return Promise.resolve(response)
                })
                .then(response => response.json())
                .then(data => {
                    console.log('response data:', data);
                    officesData = data;
                    filterOfficesMapList(data);
                })
                .catch(error => {
                    console.log('error', error)
                });
        }

    }
});
listen(filterCheckboxes, 'change', () => {
    pasteQueryToHref(modifyURL());
});
citySelect.addEventListener('change', (e) => {
    changeRegionDependOnCity(e.target.value);
    pasteQueryToHref(modifyURL());
});

regionSelect.addEventListener('change', (e) => {
    changeCityDependOnRegion(e.target.value);
});

document.addEventListener('DOMContentLoaded', (e) => {
    let selectedOption;
    if(selectedOption = v$('.js-region option[selected]')[0]) {
        let regionItem = selectedOption.value;
        changeCityDependOnRegion(regionItem);
    }
});

handlePopup(v$('#feedback')[0], v$('.js-popup-write_us')[0]);
